import React, { memo } from 'react';
import * as S from './symbol.styles';
import { Information, Sms, Viber, Whatsapp } from './symbols';
import { SymbolProps } from './symbol.types';

const MemoizedWhatsapp = memo(Whatsapp);
const MemoizedSms = memo(Sms);
const MemoizedViber = memo(Viber);
const MemoizedInformation = memo(Information);

const SymbolComponent: React.FC<SymbolProps> = ({ type, size = 20 }) => {
  const renderSymbol = () => {
    switch (type) {
      case 'whatsapp':
        return <MemoizedWhatsapp size={size} />;
      case 'sms':
        return <MemoizedSms size={size} />;
      case 'viber':
        return <MemoizedViber size={size} />;
      case 'information':
        return <MemoizedInformation size={size} />;
      default:
        return null;
    }
  };

  return <S.SymbolContainer size={size}>{renderSymbol()}</S.SymbolContainer>;
};

export const Symbol = memo(SymbolComponent);
